// @flow
import React from 'react'
import Dropzone from 'react-dropzone'
import { makeBlobURL } from 'lib/file'
import type { Field } from 'lib/types'
import FieldWrapper from './FieldWrapper'
import { httpGet } from 'lib/http'
import styles from './styles'

export default class renderS3FileUpload extends React.Component {
  props: Field
  state: {
    file: Object,
    prevInput: Object,
  }

  static defaultProps = {
    fileType: '',
    multiple: false,
  }

  constructor(props: Field) {
    super(props)
    this.state = {
      file: {},
      prevInput: {},
    }
  }

  componentDidMount() {
    // If S3 `key` is present, the preview link will direct to an S3 fetch
    this._setS3PreviewKey(this.props.input)

    // But if a new image has been dropped,
    // the preview link will display that blob instead
    this._makeBlob(this.props.input)
  }

  componentDidUpdate(prevProps) {
    const { input } = this.props
    if (prevProps.input !== input) {
      this._makeBlob(input)
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { input } = props
    if (input !== state.prevInput) {
      if (input.value.data) {
        const file = state.file
        file.preview = makeBlobURL(input.value)
        return { file, prevInput: input }
      }
    }

    return null
  }

  componentWillUnmount() {
    URL.revokeObjectURL(this.state.file.preview)
  }

  _onDrop = (files: Array<Object>) => {
    const file = files.pop()
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        URL.revokeObjectURL(this.state.file.preview)
        this.props.input.onChange({
          content_type: file.type,
          result: reader.result,
        })
      },
      false,
    )
    reader.readAsDataURL(file)
    this.setState({ file })
  }

  _makeBlob = (input: Object) => {
    if (input.value.data) {
      const file = this.state.file
      file.preview = makeBlobURL(input.value)
      this.setState({ file, prevInput: input })
    }
  }

  _setS3PreviewKey = (input: Object) => {
    if (input.value.key) {
      const file = this.state.file
      file.s3PreviewKey = input.value.key
      this.setState({ file, prevInput: input })
    }
  }

  _fetchS3File(key: string) {
    httpGet(`/admin/files/${key}/preview`).then(({ url }) => {
      window.open(url, '_blank')
    })
  }

  // See notes in componentDidMount()
  _showFile = (file: string) => {
    if (file.preview) {
      return (
        <div className={styles.previewMargin}>
          <a
            href={file.preview}
            target="_blank"
            className={styles.docLink}
            rel="noreferrer"
          >
            {this.props.label}
          </a>
        </div>
      )
    } else if (file.s3PreviewKey) {
      return (
        <div className={styles.previewMargin}>
          <a
            className={styles.docLink}
            onClick={() => this._fetchS3File(file.s3PreviewKey)}
            target="_blank"
          >
            {this.props.label}
          </a>
        </div>
      )
    } else {
      return false
    }
  }

  render() {
    const { accept, input, multiple } = this.props
    const dzProps = {
      accept,
      multiple,
      onDrop: this._onDrop,
    }
    return (
      <FieldWrapper {...this.props}>
        <div className={styles.inputContainer}>
          <input {...input} className={styles.input} type="hidden" />
          {this._showFile(this.state.file)}
          <Dropzone
            {...dzProps}
            className={styles.dropzoneArea}
            activeClassName={styles.drag}
          >
            {({ getRootProps, getInputProps }) => (
              <div className={styles.dropzoneArea} {...getRootProps()}>
                <div className={styles.upIcon} />
                <div className={styles.uploadText}>
                  Drop here or click to browse
                </div>
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
        </div>
      </FieldWrapper>
    )
  }
}
